enum FeatureType {
  CheerfulAndClean = '0', // 元気で清潔感があると言われます
  HasInsuranceOrRealEstate = '1', // 自分も自社の保険/不動産をやってます
  ManyFemaleGuests = '2', // 女性のお客様が多いです
  HighlyEducated = '3', // 学歴があり数字に強いです
  isManager = '4', // 実績があり役職についてます
  CanSimulation = '5', // 将来のシュミレーション出せます
  HasManyPattern = '6', // 何パターンもご提案できます
  GoodAfterFollow = '7', // アフターフォローにも自信あり
  EasyWord = '8', // 難しい言葉使いません
  FriendlyTone = '9' // 口調が優しいと言われます
}

export default FeatureType
